import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { putField } from "../../../../../utils/form";
import store from "../../../../../store";
import { callRequestStatus } from "../../../storage-location/request/request.section";
import { callDepartment, callRequestDoc } from "../request/request.section";
import moment from "moment";

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.sequestrate.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1"
                    ? record.refUserCompany?.companyNameTh
                    : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.sequestrate.invoiceCode"),
            dataIndex: "refReleaseProduct.refRelease.products.refInspectionProduct.refInformProduct.invoiceCode",
            align: "center",
            customRender: ({ record }) => {
                const informProduct = record.refReleaseProduct?.refInspectionProduct?.refInformProduct || {};
                return <>
                    <div>{informProduct?.invoiceCode}</div>
                    <div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div>
                </>
            }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.sequestrate.sequestrateDatetime"),
            dataIndex: "sequestrateDatetime",
            align: "center",
            format: "DD/MM/YYYY HH:mm"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.sequestrate.refRequestDoc"),
            dataIndex: "refReleaseProduct.refRelease.refInspection.refRequestDoc.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestDoc({ searchQuery }).then(d => d.filter(doc=>["02", "16", "17", "18", "19"].includes(doc?.key))),
                optLabel: "value"
            }),
            search: { name: "refReleaseProduct.refRelease.refInspection.refRequestDoc.id" },
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.sequestrateInfo.referDoc"),
            dataIndex: "refReleaseProduct.refRelease.refInspection.refInformTemp.approveCode",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.sequestrate.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
